import { SearchFilters, FilterId, SearchType } from "../../../types/search";
import { contentTypeFilterConfig } from "../../../config/filter.config";

export type SectionId = "topics" | "duration" | "sort" | "broadcastStatus";

export interface FilterConfig {
  id: FilterId;
  titleKey: string;
  type: "single" | "multiple";
  getSelectedValues: (filters: SearchFilters) => string[];
  translationPrefix: string;
  isVisible?: (contentType: SearchType) => boolean;
}

export const filterConfigs: FilterConfig[] = [
  {
    id: "topics",
    titleKey: "search.filters.topics",
    type: "multiple",
    getSelectedValues: (filters) => filters.topics || [],
    translationPrefix: "",
    isVisible: (contentType) => {
      const config = contentTypeFilterConfig[contentType];
      return config?.availableFilters.includes("topics") ?? false;
    }
  },
  {
    id: "duration",
    titleKey: "search.filters.duration",
    type: "single",
    getSelectedValues: (filters) =>
      filters.duration ? [filters.duration] : [],
    translationPrefix: "search.duration",
    isVisible: (contentType) => {
      const config = contentTypeFilterConfig[contentType];
      return config?.availableFilters.includes("duration") ?? false;
    }
  },
  {
    id: "broadcastStatus",
    titleKey: "search.filters.broadcastStatus",
    type: "multiple",
    getSelectedValues: (filters) => filters.broadcastStatus || [],
    translationPrefix: "search.broadcastStatus",
    isVisible: (contentType) => {
      const config = contentTypeFilterConfig[contentType];
      return config?.availableFilters.includes("broadcastStatus") ?? false;
    }
  },
  {
    id: "sort",
    titleKey: "search.filters.sortBy",
    type: "single",
    getSelectedValues: (filters) => (filters.sortBy ? [filters.sortBy] : []),
    translationPrefix: "search.sort",
    isVisible: (contentType) => {
      const config = contentTypeFilterConfig[contentType];
      return config?.availableFilters.includes("sort") ?? false;
    }
  },
];
